import React, { FC, useContext } from 'react'
import { StyledManageAccount, StyledOptionItem } from './ManageAccount.styled'
import { StyledIconChevron } from '../MainScreen/MainScreen.styled'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { TNLink } from '../components/TNLink'
import { tokens } from '@news-mono/design-tokens'
import { MyAccountContext } from '../hooks/useMyAccountContext'

const { utility } = tokens.thenightly.colors.palette

interface OptionItemProps {
    label: string
    text: string
    // show greyed-out edit option if disabled
    disabled?: boolean
    // hide edit option if not editable
    editable?: boolean
    hint?: JSX.Element
    onClick: () => void
}
export const OptionItem: FC<OptionItemProps> = ({
    label,
    text,
    hint,
    disabled,
    editable = true,
    onClick,
}) => {
    return (
        <StyledOptionItem
            disabled={disabled}
            onClick={onClick}
            editable={editable}
        >
            <div>
                <div className="value-wrapper">
                    <small>{label}</small>
                    <p>{text}</p>
                </div>
                {editable && (
                    <span>
                        Edit
                        <StyledIconChevron />
                    </span>
                )}
            </div>
            {hint}
        </StyledOptionItem>
    )
}
export const ManageAccount = () => {
    const authState = useSelector((state: AppState) => state.authentication)
    const { userName, userEmail, loginProvider, emailVerified } = authState
    const { setScreen } = useContext(MyAccountContext)

    const isSocialLogin = ['Google', 'Apple'].includes(loginProvider)

    const socialLink = isSocialLogin && (
        <a
            href={
                loginProvider === 'Apple'
                    ? `https://appleid.apple.com`
                    : `https://myaccount.google.com`
            }
            target="_blank"
        >
            {loginProvider}
        </a>
    )

    const verifyEmailHint = !emailVerified ? (
        <small>Verify your email to edit.</small>
    ) : undefined
    const emailHint = isSocialLogin ? (
        <small>You can review and manage your account in {socialLink}</small>
    ) : !emailVerified ? (
        verifyEmailHint
    ) : undefined

    return (
        <StyledManageAccount>
            <ul>
                <OptionItem
                    label="Name"
                    text={userName}
                    onClick={() => !isSocialLogin && setScreen('change-name')}
                    editable={!isSocialLogin}
                />
                <OptionItem
                    label="Email"
                    text={userEmail!}
                    hint={emailHint}
                    onClick={() =>
                        !isSocialLogin &&
                        emailVerified &&
                        setScreen('change-email')
                    }
                    disabled={!emailVerified}
                    editable={!isSocialLogin}
                />
                {!isSocialLogin && (
                    <OptionItem
                        label="Password"
                        text="********"
                        disabled={!emailVerified}
                        hint={verifyEmailHint}
                        onClick={() =>
                            emailVerified && setScreen('change-password')
                        }
                    />
                )}
            </ul>
            <TNLink
                color={utility.error.default}
                onClick={() => setScreen('delete-account')}
            >
                Delete account
            </TNLink>
        </StyledManageAccount>
    )
}
